import { useSelector } from "react-redux";
import StepProgressBar from "./step-progress-bar";
import { selectListItems as selectLibraryListItems } from "../../../../../redux/library/selector";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../hooks/hooks";
import { selectProductsListItems } from "../../../../../redux/products/selector";
import { selectVariantsListItems } from "../../../../../redux/variants/selector";
import { selectCategoriesListItems } from "../../../../../redux/categories/selector";
import { products } from "../../../../../redux/products/action";
import { variants } from "../../../../../redux/variants/action";
import { categories } from "../../../../../redux/categories/action";
import _ from 'lodash';
import { selectCmsSettingsListItems } from "../../../../../redux/cmsSettings/selector";
import { useNavigate } from "react-router-dom";
import { paymentMethods } from "../../../../../redux/payment-methods/action";
import storePersist from "../../../../../redux/storePersist";
import { channel } from "../../../../../redux/channel/action";
import { selectCurrent } from "../../../../../redux/settings/selectors";
import { quotes } from "../../../../../redux/quotes/action";
import { selectShippingTypesListItems } from "../../../../../redux/shippingTypes/selector";
import { shippingTypes } from "../../../../../redux/shippingTypes/action";
import { shippingProviders } from "../../../../../redux/shipping-providers/action";
import { selectShippingProvidersListItems } from "../../../../../redux/shipping-providers/selector";
import { selectPaymentMethodsQueryItems } from "../../../../../redux/payment-methods/selector";
import { addPayment } from "../../../../../redux/addPayment/action";
import { selectQuotesCreatedItem } from "../../../../../redux/quotes/selector";
import moment from "moment";
import { selectOrganizationUnitsListItems } from "../../../../../redux/organizationUnits/selector";
import { orders } from "../../../../../redux/orders/action";
import queryString from "query-string";
import CryptoJS from 'crypto-js';
import { selectOrdersCreatedItem } from "../../../../../redux/orders/selector";
import { leads } from "../../../../../redux/leads/action";
import { selectLeadsCreatedItem } from "../../../../../redux/leads/selector";
import { toast } from "react-toastify";

export default function OrderBookingMobile() {
  const result = useSelector(selectCurrent)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const paymentSettings = useSelector(selectCmsSettingsListItems)
  const libraryData = useSelector(selectLibraryListItems)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [generateIds, setGenerateIds] = useState<any>([]);
  const [quoteData, SetQuoteData] = useState<any>({});
  const [addPackageItem, setAddPackageItem] = useState<any>(undefined);
  const [selectedPackageItem, setSelectedPackageItem] = useState<any>([])
  const [packageItem, setPackageItem] = useState<any>([])
  const [selectedTime, setSelectedTime] = useState<any>(null);
  const [selectedDate, setSelectedDate] = useState<any>(null);
  const [activeSteps, setActiveSteps] = useState(1)
  const [enablePlaceOrder, setEnablePlaceOrder] = useState(false);
  const [paymentSelectedInput, setPaymentSelectedInput] = useState<any>(undefined);
  const [paymentMode, setPaymentMode] = useState<any>(undefined);
  const [steps, setSteps] = useState([{ id: 1, label: "Step 1", completed: true }, { id: 2, label: "Step 2", completed: false }, { id: 3, label: "Step 3", completed: false }, { id: 4, label: "Step 4", completed: false }, { id: 5, label: "Step 5", completed: false }]);
  const [pickupLocations, setPickupLocation] = useState<any>({
    name: result?.searchedLocation?.name || '',
    lat: result?.searchedLocation?.lat || '',
    lng: result?.searchedLocation?.lng || '',
    pincode: result?.searchedLocation?.pincode || '',
    description: result?.searchedLocation?.description || '',
  });
  const [dropLocations, setDropLocation] = useState<any>({
    name: result?.searchedToLocation?.name || '',
    lat: result?.searchedToLocation?.lat || '',
    lng: result?.searchedToLocation?.lng || '',
    pincode: result?.searchedToLocation?.pincode || '',
    description: result?.searchedToLocation?.description || '',
  });
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>()
  const [columnDefs, setColumnDefs] = useState({});
  const [razorpaySettings, setRazorpaySettings] = useState<any>([])
  const [paymentGateway, setPaymentGateway] = useState<any>([]);
  const [isOrderPlaced, setIsOrderPlaced] = useState<any>(false);
  const [isPaymentAdded, setIsPaymentAdded] = useState<any>(false);
  const [selected, setSelected] = useState<any>();
  const [totalValue, setTotalValue] = useState(0);

  const leadCreateData = useSelector(selectLeadsCreatedItem)
  const paymentMethodQuery = useSelector(selectPaymentMethodsQueryItems)
  const ProductLists = useSelector(selectProductsListItems)
  const variantLists = useSelector(selectVariantsListItems)
  const categoryListItems = useSelector(selectCategoriesListItems)
  const shippingTypesDetails = useSelector(selectShippingTypesListItems)
  const shippingProvidersListItems = useSelector(selectShippingProvidersListItems)
  const quoteDetails = useSelector(selectQuotesCreatedItem)
  const organizationUnitLists = useSelector(selectOrganizationUnitsListItems)
  var tenantId = storePersist.get('guestTokenMetadata')?.current?.result?.TokenMetadata?.TenantId
  var storeId = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization?.StoreId;
  const orderDetails = useSelector(selectOrdersCreatedItem)
  const MODE = 'secure';
  const userProfileData = storePersist?.get("userProfile")?.current?.items[0]?.Message;
  const handleChange: any = (event: any, field: string) => {
    SetQuoteData({ ...quoteData, [field]: event })
  }

  const closeModal = () => {
    setAddPackageItem(undefined)
    setSelectedPackageItem('')
  }


  // start Package item function

  const PackageType = [
    { name: 'Standard Package' },
    { name: 'Custom Package' }
  ]

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'categoryName', headerName: 'Category' },
      { field: 'productName', headerName: 'Product' },
      { field: 'variantName', headerName: 'Variant', },
      { field: 'quantity', headerName: 'Quantity' },

    ]);
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedPackageItem({ ...selectedPackageItem, [field]: event });
  }

  const handleAddItem = () => {
    setAddPackageItem({
      id: 0
    });
  }

  const handleEdit = (itemData: any) => {
    setAddPackageItem({
      id: itemData.id
    })
    setSelectedPackageItem(itemData)
  }
  const handlePackageItemSubmit = async (data: any) => {
    if (
      !data?.packageType ||
      !data?.CategoryId ||
      !data?.LogisticsProductId ||
      !data?.LogisticsVariantId ||
      !data?.quantity ||
      !data?.value
    ) {
      await setIsLoading(false)
      toast.error("All fields are required. Please fill in all the details.");
      return;
    }
    // Find the related category, product, and variant names
    let categoryName = _.find(categoryListItems?.result?.items, ['Id', data?.CategoryId]);
    let productName = _.find(ProductLists?.result?.items, ['Id', data?.LogisticsProductId]);
    let variantName = _.find(variantLists?.result?.items, ['Id', data?.LogisticsVariantId]);

    // Collect new form data
    const newPackageItem = {
      id: data?.id || Date.now(),  // Use existing id for editing or generate a new one
      packageType: data?.packageType || '',
      dangerous_goods: data?.dangerous_goods || false,
      CategoryId: data?.CategoryId || 0,
      categoryName: categoryName?.Name || '',
      LogisticsProductId: data?.LogisticsProductId || 0,
      productName: productName?.Name || '',
      LogisticsVariantId: data?.LogisticsVariantId || 0,
      variantName: variantName?.Name || '',
      weight: data?.weight || 0,
      value: data?.value || 0,
      quantity: data?.quantity || 0,
      measure: data?.measure || 0,
      breadth: data?.breadth || 0,
      height: data?.height || 0,
      length: data?.length || 0,
      item_description: data?.item_description || '',
    };

    setPackageItem((prevState: any) => {
      // Check if the item exists by ID
      const exists = prevState.some((item: any) => item.id === newPackageItem.id);
      // If it exists, update it, otherwise add the new item
      return exists
        ? prevState.map((item: any) => item.id === newPackageItem.id ? newPackageItem : item)
        : [...prevState, newPackageItem];
    });
    closeModal();
    setSelectedPackageItem('');
  };

  const handleDelete = (data: any) => {
    setPackageItem((prevState: any) =>
      prevState.filter((item: any) => item.id !== data.id)
    );
  };
  // End Package item function

  useEffect(() => {

    if (!isOpenComponent && activeSteps == 4 && quoteDetails?.isSuccess) {

      setActiveSteps(4 + 1)
      setSteps([{ id: 1, label: "Step 1", completed: true },
      { id: 2, label: "Step 2", completed: true },
      { id: 3, label: "Step 3", completed: true },
      { id: 4, label: "Step 4", completed: true },
      { id: 5, label: "Step 5", completed: true }])
    }
  }, [activeSteps])

  // Calculate total Product value
  useEffect(() => {
    const sum = packageItem
      .filter(item => item.value) // Remove empty objects
      .reduce((sum, item) => sum + Number(item.value), 0);
    setTotalValue(sum);
  }, [packageItem]);

  // Check condition
  const isOpenComponent = totalValue >= 50000;

  // Start Step progress
  const handleSteps = async () => {
    if (activeSteps == 1) {
      setActiveSteps(activeSteps + 1)
      setSteps([
        { id: 1, label: "Step 1", completed: true },
        { id: 2, label: "Step 2", completed: true },
        { id: 3, label: "Step 3", completed: false },
        { id: 4, label: "Step 4", completed: false },
        { id: 5, label: "Step 5", completed: false }])
    }
    else if (activeSteps == 2) {
      setActiveSteps(activeSteps + 1)
      setSteps([{ id: 1, label: "Step 1", completed: true },
      { id: 2, label: "Step 2", completed: true },
      { id: 3, label: "Step 3", completed: true },
      { id: 4, label: "Step 4", completed: false },
      { id: 5, label: "Step 5", completed: false }])
    }
    else if (activeSteps == 3) {
      await handleSaveQuote()

    }
    else if (activeSteps == 4) {
      setActiveSteps(activeSteps + 1)
      setSteps([{ id: 1, label: "Step 1", completed: true },
      { id: 2, label: "Step 2", completed: true },
      { id: 3, label: "Step 3", completed: true },
      { id: 4, label: "Step 4", completed: true },
      { id: 5, label: "Step 5", completed: true }])
    }
    else if (activeSteps == 5) {
      dispatch(quotes.resetAction({ actionType: 'create' }))
      dispatch(leads.resetAction({ actionType: 'create' }))
      localStorage.removeItem('access-token')
      localStorage.removeItem('accessTokenMetadata')
      localStorage.removeItem('userProfile')
      navigate('/')
    }
  }
  const handleBookLater = () => {
    setActiveSteps(1)
    setSteps([{ id: 1, label: "Step 1", completed: true },
    { id: 2, label: "Step 2", completed: false },
    { id: 3, label: "Step 3", completed: false },
    { id: 4, label: "Step 4", completed: false },
    { id: 5, label: "Step 5", completed: false }])
    dispatch(quotes.resetAction({ actionType: 'create' }))
    dispatch(leads.resetAction({ actionType: 'create' }))
    localStorage.removeItem('access-token')
    localStorage.removeItem('accessTokenMetadata')
    localStorage.removeItem('userProfile')
    navigate('/')
  }

  const handleBackSteps = () => {
    if (activeSteps === 2) {
      setActiveSteps(activeSteps - 1);
      setSteps([
        { id: 1, label: "Step 1", completed: true },
        { id: 2, label: "Step 2", completed: false },
        { id: 3, label: "Step 3", completed: false },
        { id: 4, label: "Step 4", completed: false },
        { id: 5, label: "Step 5", completed: false }
      ]);
    } else if (activeSteps === 3) {
      setActiveSteps(activeSteps - 1);
      setSteps([
        { id: 1, label: "Step 1", completed: true },
        { id: 2, label: "Step 2", completed: true },
        { id: 3, label: "Step 3", completed: false },
        { id: 4, label: "Step 4", completed: false },
        { id: 5, label: "Step 5", completed: false }
      ]);
    } else if (activeSteps === 4) {
      setActiveSteps(activeSteps - 1);
      setSteps([
        { id: 1, label: "Step 1", completed: true },
        { id: 2, label: "Step 2", completed: true },
        { id: 3, label: "Step 3", completed: true },
        { id: 4, label: "Step 4", completed: false },
        { id: 5, label: "Step 5", completed: false }
      ]);
    } else if (activeSteps === 5) {
      setActiveSteps(activeSteps - 1);
      setSteps([
        { id: 1, label: "Step 1", completed: true },
        { id: 2, label: "Step 2", completed: true },
        { id: 3, label: "Step 3", completed: true },
        { id: 4, label: "Step 4", completed: true },
        { id: 5, label: "Step 5", completed: true }
      ]);
    }
  };

  // End step progress

  // Start generate Unique ID
  const generateUniqueId = () => {
    const randomPart = Math.random().toString(36).substr(2, 9); // Random part
    const timestampPart = Date.now().toString(36); // Timestamp part
    return `${randomPart}-${timestampPart}`;
  };

  const generateIdValue = () => {
    const newItem = {
      transaction_id: generateUniqueId(),
      message_id: generateUniqueId(),
      fulfillment_id: generateUniqueId(),
      item_id: generateUniqueId(),
      order_id: generateUniqueId(),
    };
    setGenerateIds(newItem);
  };
  // End generate Unique ID



  const handlePaymentInput = (e: any, item: any) => {
    setSelected(item.value)
    setPaymentMode(item)
    setPaymentSelectedInput(e.target.value)
  }

  // Step 1: Submit Quotes
  const handleSaveQuote = async () => {
    await setIsLoading(true)
    // Validation for required fields
    if (
      !quoteData?.pickupContactName ||
      !quoteData?.pickupMobileNumber ||
      !quoteData?.dropContactName ||
      !selectedDate ||
      !quoteData?.shipping ||
      !pickupLocations?.description ||
      !quoteData?.dropMobileNumber ||
      !dropLocations?.description
    ) {
      await setIsLoading(false)
      toast.error("All fields are required. Please fill in all the details.");
      return;
    }

    // let shippingType = _.find(shippingTypesDetails.result.items, ['ShippingTypeName', 'Immediate Delivery']);
    let shippingType = shippingTypesDetails.result.items[0];
    const fromAddressData = _.split(pickupLocations?.description, ',');
    const toAddressData = _.split(dropLocations?.description, ',');

    const selectedProducts = packageItem?.map((item: any) => {
      const product = {
        CategoryId: item?.CategoryId,
        LogisticsProductId: item?.LogisticsProductId,
        LogisticsVariantId: item?.LogisticsVariantId,
        quantity: {
          count: item?.quantity,
          measure: {
            unit: "kg",
            value: item?.measure || 0
          }
        },
        weight: {
          unit: "mm",
          value: item?.weight || 0
        },
        dimensions: {
          length: {
            unit: "mm",
            value: item?.length || 0
          },
          breadth: {
            unit: "mm",
            value: item?.breadth || 0
          },
          height: {
            unit: "mm",
            value: item?.height || 0
          }
        },
        value: {
          currency: "INR",
          value: item?.value || 0
        },
        dangerous_goods: item?.dangerous_goods
      }
      return product;
    });
    const valueData = {
      order: {
        IsCargoOrder: false,
        provider: {
          id: shippingProvidersListItems?.result?.items[0]?.AccountPId,
          locations: []
        },
        items:
          [{
            id: String(shippingType.Id),
            fulfillment_id: generateIds?.fulfillment_id,
            category_id: shippingType?.ShippingTypeName,
            descriptor: {
              code: "P2P" // shipmentType (library call)
            },
            time: {
              label: "",
              duration: String(selectedTime),
              timestamp: String(selectedDate)
            }
          }],
        billing: {},
        payment: {},
        LinkedItems: selectedProducts,
        fulfillments: [
          {
            id: generateIds?.fulfillment_id,
            type: quoteData?.shipping,
            start: {
              location: {
                gps: `${pickupLocations?.lat} ,${pickupLocations?.lng}`,
                address: {
                  name: quoteData?.pickupContactName,
                  building: quoteData?.pickupAdditionaInfo,
                  locality: `${fromAddressData[0]},${fromAddressData[1]}`,
                  city: pickupLocations?.name,
                  state: fromAddressData[3] || 'TamilNadu',
                  country: 'India',
                  area_code: pickupLocations?.pincode || ''
                }
              },
              contact: {
                phone: quoteData?.pickupMobileNumber,
                email: quoteData?.pickupEmail || ''
              }
            },
            end: {
              location: {
                gps: `${dropLocations?.lat} ,${dropLocations?.lng}`,
                address: {
                  name: quoteData?.dropContactName,
                  building: quoteData?.dropAdditionaInfo,
                  locality: `${toAddressData[0]},${toAddressData[1]}`,
                  city: dropLocations?.name,
                  state: toAddressData[3] || 'TamilNadu',
                  country: 'India',
                  area_code: dropLocations?.pincode || ''
                }
              },
              contact: {
                phone: quoteData?.dropMobileNumber,
                email: quoteData?.dropEmail || ''
              }
            }
          }
        ]
      }
    }


    await dispatch(quotes.create(
      {
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/logistics-quotes`, entity: 'quotes',
        jsonData: {
          Records: [{
            context: {
              transaction_id: leadCreateData?.result?.Records[0]?.Context?.transaction_id,
              message_id: generateIds?.item_id,
            },
            message: valueData,
          }]
        }
      }))
    await setIsLoading(false)
  }
  useEffect(() => {

    if (quoteDetails && quoteDetails?.isSuccess) {
      setPickupLocation({
        name: '',
        lat: '',
        lng: '',
        pincode: '',
        description: ''
      })
      setDropLocation({
        name: '',
        lat: '',
        lng: '',
        pincode: '',
        description: ''
      })

      setActiveSteps(activeSteps + 1)
      setSteps([{ id: 1, label: "Step 1", completed: true },
      { id: 2, label: "Step 2", completed: true },
      { id: 3, label: "Step 3", completed: true },
      { id: 4, label: "Step 4", completed: true },
      { id: 5, label: "Step 5", completed: false }])
    }
  }, [quoteDetails])

  // Step 2: Add Payment
  const handlePayment = async () => {
    await setIsLoading(true)
    await dispatch(addPayment.update({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/check-outs/add-payment`, entity: 'addPayment', jsonData: {
        Records: [
          {
            Context: {
              transaction_id: quoteDetails?.result?.Records[0]?.context?.transaction_id,
              message_id: generateIds?.message_id,
            },
            Message: {
              Id: quoteDetails?.result?.Records[0]?.message?.order?.Id,
              OwnerType: 'LogisticsOrder',
              PaidAmount: quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup[0]?.price?.value,
              PaymentRemarks: 'LogisticsOrder',
              PaymentMethodId: selected, // Number(sessionStorage.getItem('paymentmethod')),
              PaymentGatewayId: paymentGateway[0]?.Id || 0,
            },
          }

        ],
      }
    }))
    await dispatch(orders.resetAction({ actionType: 'create' }))
    await setIsPaymentAdded(true);


  };

  // Step 4: Confirm Logistics Order
  useEffect(() => {
    if (isPaymentAdded) {

      const itemValues = quoteDetails?.result?.Records[0]?.message?.order?.items?.map((item: any) => {
        const data = {
          id: item?.id,
          fulfillment_id: item?.fulfillment_id,
          category_id: item?.category_id,
          descriptor: {
            code: item?.descriptor?.code
          },
          time: {
            label: null,
            duration: item?.time?.duration,
            timestamp: item?.time?.timestamp
          }
        };
        return data;
      });

      const breakupValues = quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup?.map((item: any) => {
        const data = {
          "@ondc/org/item_id": item?.['@ondc/org/item_id'],
          "@ondc/org/title_type": item?.['@ondc/org/title_type'],
          "price": {
            "currency": item?.price?.currency,
            "value": item?.price?.value
          }
        };
        return data;
      });
      const fulfillmentValues = quoteDetails?.result?.Records[0]?.message?.order?.fulfillments?.map((item: any) => {
        const data = {
          "id": item?.id,
          "type": item?.type,
          "@ondc/org/awb_no": null,
          "start": {
            "person": {
              "name": ''
            },
            "location": {
              "gps": item?.start?.location?.gps,
              "address": {
                "name": item?.start?.location?.address?.name,
                "building": item?.start?.location?.address?.building,
                "locality": item?.start?.location?.address?.locality,
                "city": item?.start?.location?.address?.city,
                "state": item?.start?.location?.address?.state,
                "country": item?.start?.location?.address?.country,
                "area_code": item?.start?.location?.address?.area_code
              }
            },
            "contact": {
              "phone": item?.start?.contact?.phone,
              "email": item?.start?.contact?.email
            },
            "instructions": {
              "code": null,
              "short_desc": null,
              "long_desc": null,
              "additional_desc": {
                "content_type": null,
                "url": null
              },
              "images": null

            },
            "time": {
              "label": null,
              "duration": null,
              "timestamp": null
            }
          },
          "end": {
            "person": {
              "name": ''
            },
            "location": {
              "gps": item?.end?.location?.gps,
              "address": {
                "name": item?.end?.location?.address?.name,
                "building": item?.end?.location?.address?.building,
                "locality": item?.end?.location?.address?.locality,
                "city": item?.end?.location?.address?.city,
                "state": item?.end?.location?.address?.state,
                "country": item?.end?.location?.address?.country,
                "area_code": item?.end?.location?.address?.area_code
              }
            },
            "contact": {
              "phone": item?.end?.contact?.phone || '',
              "email": item?.end?.contact?.email || ''
            },
            "instructions": {
              "code": null,
              "short_desc": null,
              "long_desc": null,
              "additional_desc": {
                "content_type": null,
                "url": null
              },
              "images": null
            },
            "time": {
              "label": null,
              "duration": null,
              "timestamp": null
            }
          },
          "agent": {},
          "vehicle": {},
          "EWayBill": {
            "MediaFiles": isOpenComponent ? mediaFiles : [],
            "Templates": []
          },
          "@ondc/org/ewaybillno": null,
          "@ondc/org/ebnexpirydate": null,
          "tags": [
            {
              "code": null,
              "list": [
                {
                  "code": null,
                  "value": null
                }
              ]
            }
          ]
        };
        return data;
      });
      const linkedItemValues = quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems?.map((item: any) => {
        let category = _.find(categoryListItems?.result?.items, ['Id', item?.CategoryId]);
        let product = _.find(ProductLists?.result?.items, ['Id', item?.LogisticsProductId]);
        const data = {
          "CategoryName": category?.Name,
          "CategoryId": item?.CategoryId,
          "LogisticsProductId": item?.LogisticsProductId,
          "LogisticsVariantId": item?.LogisticsVariantId,
          "descriptor": {
            "name": product?.Name
          },
          "quantity": {
            "count": item?.quantity?.count,
            "measure": {
              "unit": item?.quantity?.measure?.unit,
              "value": item?.quantity?.measure?.value
            }
          },

          "price": {
            "currency": item?.value?.currency,
            "value": item?.value?.value
          },
          "dangerous_goods": item?.dangerous_goods
        };
        return data;
      });
      const tagValues = quoteDetails?.result?.Records[0]?.message?.order?.tags?.map((item: any) => {
        const data = {
          code: item?.code,
          list: item?.list?.map((listItem: any) => {
            const data = {
              "code": listItem?.code,
              "value": listItem?.value
            }
            return data;

          })
        };
        return data;
      });
      const orderData = {
        context: {
          transaction_id: quoteDetails?.result?.Records[0]?.context?.transaction_id,
          message_id: generateIds?.fulfillment_id,
        },
        message: {
          order: {
            created_at: moment.utc(),
            updated_at: moment.utc(),
            id: generateIds.order_id,
            state: null,
            IsCargoOrder: false,
            provider: {
              id: quoteDetails?.result?.Records[0]?.message?.order?.provider?.id,
              locations: quoteDetails?.result?.Records[0]?.message?.order?.provider?.locations
            },
            items: itemValues,
            quote: {
              price: {
                currency: quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.currency,
                value: quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.value,
              },
              breakup: breakupValues
            },
            fulfillments: fulfillmentValues,
            "billing": {
              "name": fulfillmentValues[0]?.start?.person?.name || '',
              "address": {
                "name": fulfillmentValues[0]?.start?.location?.address?.name || '',
                "building": fulfillmentValues[0]?.start?.location?.address?.building || '',
                "locality": fulfillmentValues[0]?.start?.location?.address?.locality || '',
                "city": fulfillmentValues[0]?.start?.location?.address?.city || '',
                "state": fulfillmentValues[0]?.start?.location?.address?.state || '',
                "country": fulfillmentValues[0]?.start?.location?.address?.country || '',
                "area_code": fulfillmentValues[0]?.start?.location?.address?.area_code || '',
              },
              "tax_number": '',
              "phone": fulfillmentValues[0]?.start?.contact?.phone || '',
              "email": fulfillmentValues[0]?.start?.contact?.email || '',

            },
            "payment": {
              "@ondc/org/collection_amount": null,
              "collected_by": null,
              "type": null,
              "@ondc/org/settlement_details": [
                {
                  "settlement_counterparty": null,
                  "settlement_type": null,
                  "upi_address": null,
                  "settlement_bank_account_no": null,
                  "settlement_ifsc_code": null
                }
              ]
            },
            "@ondc/org/linked_order": {
              "items": linkedItemValues,
              "provider": {
                "descriptor": {
                  "name": null
                },
                "address": {
                  "name": organizationUnitLists?.result?.items[0]?.Name,
                  "building": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Address1,
                  "locality": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Address2,
                  "city": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.City,
                  "state": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.StateProvince?.Name,
                  "country": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Country?.Name,
                  "area_code": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.ZipPostalCode
                }
              },
              "order":
              {
                "id": null,
                "weight": {
                  "unit": "mm",
                  "value": 600
                },
                "dimensions": {
                  "length": {
                    "unit": "mm",
                    "value": 50
                  },
                  "breadth": {
                    "unit": "mm",
                    "value": 60
                  },
                  "height": {
                    "unit": "mm",
                    "value": 30
                  }
                }
              }

            },
            "tags": tagValues,

          }
        }
      }
      dispatch(orders.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/confirm-logistics-order`,
        entity: 'orderCreate',
        jsonData: {
          Records: [orderData]
        }
      })).then(() => {
        setIsLoading(false)
        setIsOrderPlaced(true)

      })
    }
  }, [isPaymentAdded])

  // Start- ccAvenue function
  const encrypt1 = (plainText: string, workingKey: string): string => {
    // Create an MD5 hash of the workingKey
    const key = CryptoJS.MD5(workingKey).toString(CryptoJS.enc.Hex);

    // Initialization vector (IV)
    const iv = CryptoJS.enc.Hex.parse('000102030405060708090a0b0c0d0e0f');

    // Encrypt the plainText
    const encrypted = CryptoJS.AES.encrypt(plainText, CryptoJS.enc.Hex.parse(key), {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Return the encrypted text in hex format
    return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
  };

  const handeCCAvenuePayment = (orderDetails: any) => {
    const workingKey =
      razorpaySettings.CCAvenue?.WorkingKey; //Put in the 32-Bit key shared by CCAvenues.
    const accessCode =
      razorpaySettings.CCAvenue?.AccessCode;
    const merchantId =
      razorpaySettings.CCAvenue?.MerchantId;

    const companyName = localStorage.getItem("CompanyName");
    const channelId = storePersist.get("accessTokenMetadata").current?.TokenMetadata?.SalesChannelId;
    const tenant = companyName; //getBusinessCompanyName();


    // const guestTokenData = {
    // 	Channel: channel.SalesChannelName, //SalesChannelName(),
    // 	Requester: `https://${tenant}.csp.digiit.${process.env.REACT_APP_API_URL}/`,
    // 	StoreId: storeId,
    // 	SalesChannelId: ChannelId,
    // };
    // const accessTokenData = {
    // 	PhoneNumber: userInfo[0]?.PhoneNumber,
    // 	TenantName: tenant,
    // 	SalesChannelId: ChannelId,
    // };
    const ccAvenueData = {
      merchant_id: merchantId,
      order_id: orderDetails?.order?.id,
      currency: 'INR',
      amount: Number(orderDetails?.order?.quote?.price?.value), //Total Price,
      //   ENABLE WHILE TESTING LOCALLY. NEEDS TO BE RUN ALONG WITH PAYMENTS REPO.
      //   redirect_url: `http://localhost:3004/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${billingAddress?.PhoneNumber}/ccavResponseHandler`,
      //   cancel_url: `http://localhost:3004/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${billingAddress?.PhoneNumber}/ccavResponseHandler`,

      // ENABLE FOR PRODUCTION
      redirect_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${userProfileData?.PhoneNumber}/ccavResponseHandler`,
      cancel_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${userProfileData?.PhoneNumber}/ccavResponseHandler`,

      language: 'EN',
      billing_name: orderDetails?.order?.billing?.address?.name,
      billing_address: orderDetails?.order?.billing?.address?.locality,
      billing_city: orderDetails?.order?.billing?.address?.city,
      billing_state: orderDetails?.order?.billing?.address?.state,
      billing_zip: orderDetails?.order?.billing?.address?.area_code,
      billing_country: orderDetails?.order?.billing?.address?.country,
      billing_tel: userProfileData?.PhoneNumber,
      billing_email: userProfileData?.Email,
      delivery_name: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.name,
      delivery_address: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.locality,
      delivery_city: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.city,
      delivery_state: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.state,
      delivery_zip: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.area_code,
      delivery_country: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.country,
      merchant_param1: tenant, //getOrganizationName(),
      merchant_param2: tenantId,
      merchant_param3: `${window.location.hostname}`,
      merchant_param4: 'customer/order-detail',
      merchant_param5: '',
      integration_type: 'iframe_normal',
      // promo_code:'PROMO8513',
      customer_identifier: userProfileData?.Email,
    };
    const body = queryString.stringify(ccAvenueData);

    const encRequest1 = encrypt1(body, workingKey);
    // let URL = `https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;
    let URL = `https://${MODE}.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;
    window.location.href = URL;
    // router.push(URL);

  }
  console.log("steps:", steps, "Active", activeSteps)
  useEffect(() => {
    if (isOrderPlaced) {
      switch (selected) {
        case 10: //cash payment
          navigate('/customer/order-detail')
          break;
        case 20: //online
          switch (paymentGateway[0]?.Id) {
            case 10: //razorpay
              // handeRazorpay()
              break;
            case 20: //ccavenue
              handeCCAvenuePayment(orderDetails?.result?.items?.Records[0]?.message)
              break;
            case 30: //phonepe
              break;
            default:
          }


          break;
        case 30: //wallet
          break;
      }

    }
  }, [isOrderPlaced])

  useEffect(() => {
    setRazorpaySettings(paymentMethodQuery?.result?.items?.RazorPayConfiguration);
  }, [paymentMethodQuery]);


  useEffect(() => {
    if (paymentMode) {
      if (paymentMode.name == 'Cash' || paymentMode.name == 'Wallet') {
        setPaymentGateway([]);
        setEnablePlaceOrder(true)
      } else if (paymentMode && razorpaySettings) {

        const gateways: any = []
        if (razorpaySettings?.RazorPay?.IsActive) {
          gateways.push({ Id: 10, title: 'Razorpay', detail: 'Razorpay' })
        }
        if (razorpaySettings?.CCAvenue?.IsActive) {
          gateways.push({ Id: 20, title: 'CC Avenue', detail: 'CC Avenue' })
        }
        if (razorpaySettings?.PhonePe?.IsActive) {
          gateways.push({ Id: 30, title: 'PhonePe', detail: 'PhonePe' })
        }
        setPaymentGateway(gateways);
        setEnablePlaceOrder(true)
      } else {
        setEnablePlaceOrder(false)
      }
    }
  }, [paymentMode])


  useEffect(() => {
    generateIdValue()
    setAddPackageItem(undefined)
    createColumnDefs()
    dispatch(shippingTypes.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipping-types/list`, entity: 'shippingTypes', jsonData: {} }))
      .then(() => {
        dispatch(shippingProviders.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/shipment-management/shipping-providers/list`, entity: 'shippingProviders', jsonData: {
          }
        }))
      }).then(() => {
        dispatch(products.list({ url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/products/list`, entity: 'products', jsonData: {} }))
      }).then(() => {
        dispatch(variants.list({
          url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/variants/list`, entity: 'variants', jsonData: {}
        }))
      }).then(() => {
        dispatch(categories.list({
          url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/categories/list`,
          entity: 'categories',
          jsonData: {}
        }));
      }).then(() => {
        dispatch(paymentMethods.query({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/configuration/payment-management/payment-methods/query-by-tenants`, entity: 'paymentMethods', jsonData:
            { "Tenants": [{ "Id": tenantId }] }
        }))
      }).then(() => {
        dispatch(channel.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/channels/list`, entity: 'channels', jsonData: {} }))
      })
  }, []);
  const handleFileURlSubmit = async (urlData) => {
    await setMediaFiles(
      [{
        Id: 0,
        FileTypeId: urlData?.FileType === 'image' ? 10 : 20,
        OwnerId: 0,
        OwnerType: "shipping",
        OwnerTypeId: 1007,
        FileMappingURL: urlData?.DocumentPath
      }]
    )
    await setActiveSteps(4 + 1)
    await setSteps([{ id: 1, label: "Step 1", completed: true },
    { id: 2, label: "Step 2", completed: true },
    { id: 3, label: "Step 3", completed: true },
    { id: 4, label: "Step 4", completed: true },
    { id: 5, label: "Step 5", completed: true }])

  }

  return (
    <>
      <StepProgressBar
        handleFileURlSubmit={handleFileURlSubmit}
        isLoading={isLoading}
        setSelectedTime={setSelectedTime}
        setSelectedDate={setSelectedDate}
        shippingTypesDetails={shippingTypesDetails}
        enablePlaceOrder={enablePlaceOrder}
        handlePaymentInput={handlePaymentInput}
        paymentSelectedInput={paymentSelectedInput}
        activeSteps={activeSteps}
        steps={steps}
        handlePayment={handlePayment}
        handleSteps={handleSteps}
        handleBackSteps={handleBackSteps}
        paymentSettings={paymentSettings}
        handleDelete={handleDelete}
        handlePackageItemSubmit={handlePackageItemSubmit}
        closeModal={closeModal}
        handleEdit={handleEdit}
        handleAddItem={handleAddItem}
        PackageType={PackageType}
        handleInnerFormChange={handleInnerFormChange}
        columnDefs={columnDefs}
        categoryListItems={categoryListItems}
        variantLists={variantLists}
        ProductLists={ProductLists}
        packageItem={packageItem}
        selectedPackageItem={selectedPackageItem}
        addPackageItem={addPackageItem}
        dropLocations={dropLocations}
        setDropLocation={setDropLocation}
        pickupLocations={pickupLocations}
        setPickupLocation={setPickupLocation}
        libraryData={libraryData}
        quoteData={quoteData}
        handleChange={handleChange}
        quoteDetails={quoteDetails}
        handleBookLater={handleBookLater}
      />
    </>

  );
}
